export * from '@primeuix/themes/nora/ripple';
export { default } from '@primeuix/themes/nora/ripple';
